// Library methods
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

// MUI Components
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import SearchBox from "../SearchBox";
import DefaultModal from "../DefaultModal";

// Styles
import {
  CustomTextFieldOutlined,
  ModalCustomCancel,
  ModalCustomConfirm,
  CustomTextFieldOutlinedInputProps,
} from "../../../styles/muiStylesHelper";

const ClinicModalShared = ({
  open,
  onClose,
  onConfirm,
  onCancel,
  clinicName,
  setClinicName,
  clinicTZ,
  setClinicTZ,
  title,
  confirmButtonTitle,
  allTimezoneInfo = [],
}) => {
  // internationalization
  const { t } = useTranslation();

  const shouldDisable = useMemo(() => {
    let isIncluded = 0;
    allTimezoneInfo.forEach((tz) => {
      if (clinicTZ?.name === tz.name) isIncluded++;
    });
    return !clinicName || !clinicName?.trim()?.length || isIncluded !== 1;
  }, [allTimezoneInfo, clinicName, clinicTZ]);

  return (
    <DefaultModal
      isOpen={open}
      onClose={onClose}
      title={t(title)}
      maxWidth="xs"
      modalActions={
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          <Button variant="text" onClick={onCancel} sx={ModalCustomCancel}>
            {t("button_cancel")}
          </Button>
          <Button
            variant="outlined"
            sx={ModalCustomConfirm}
            color="primary"
            disabled={shouldDisable}
            onClick={onConfirm}
          >
            {t(confirmButtonTitle)}
          </Button>
        </Grid>
      }
    >
      <Grid display="flex" flexDirection="column" p="20px" gap="20px">
        {/* clinic name field*/}
        <TextField
          id="outlined-basic"
          value={clinicName}
          onChange={(e) => setClinicName(e.target.value)}
          label={t("clinic_modal_clinic_name")}
          sx={() => CustomTextFieldOutlined({ mt: 0 })}
          InputProps={{
            sx: CustomTextFieldOutlinedInputProps,
          }}
          variant="outlined"
          fullWidth
          color="warning"
        />
        <SearchBox
          data={allTimezoneInfo}
          state={clinicTZ}
          setState={setClinicTZ}
          propertyBit={1}
        />
      </Grid>
    </DefaultModal>
  );
};

export default ClinicModalShared;
